import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FunctionalLoader } from 'seagull';
import { useStoreActions } from '~/contexts';
import AgreementStudioTemplates from '../../components/AgreementStudioPage/AgreementStudioTemplateMode/AgreementStudioTemplates';
import { makeSentryIgnoredError } from '../../components/ErrorBoundaryPage';
export default function ProposalTemplateLoader(props) {
    const { api } = useStoreActions();
    const { templateId } = props.match.params;
    const [template, setTemplate] = useState({
        data: undefined,
        error: null
    });
    useEffect(()=>{
        setTemplate({
            data: undefined,
            error: undefined
        });
        api.proposalTemplates.get(templateId).then((res)=>setTemplate({
                data: res,
                error: undefined
            }), (err)=>setTemplate({
                data: undefined,
                error: err
            }));
    }, [
        templateId
    ]);
    if (template.error) {
        throw makeSentryIgnoredError('Failed to fetch template');
    } else if (!template.data) {
        return /*#__PURE__*/ _jsx(FunctionalLoader, {
            name: "ProposalTemplateLoader",
            show: true
        });
    } else {
        return /*#__PURE__*/ _jsx(AgreementStudioTemplates, _object_spread_props(_object_spread({}, props), {
            template: template.data
        }));
    }
}
